const COOKIE_KEY = 'IS_SELENIUM';

// Using a cookie works better than LocalStorage because it will persist across sub-domains
// a local storage variable would have to be managed per sub domain (per vault).
const cookieVals = document.cookie.split(';') || [];

const isAutomation = cookieVals.some(
    (cookie) => `${COOKIE_KEY}=true` === (cookie && cookie.trim()),
);

const getTargetAttribute = (targetName) => (isAutomation ? targetName : undefined);

export default getTargetAttribute;
